module.exports = __webpack_public_path__ + "img/1551.d758cf93.gif";